<template>
  <div class="vf-flex vf-items-center vf-gap-x-3">
    <img :src="logoUrl" style="height: 30px !important" />
    <h4 class="">Lenna.ai</h4>
  </div>

  <div class="vf-text-center vf-px-6 vf-mt-6 vf-mb-10">
    <img
      src="@/assets/images/open-platform/checks.png"
      class="mx-auto block mb-4"
      style="height: 60px !important"
    />
    <h3 class="vf-text-2xl vf-mb-2">
      All Set! Let's Start Serving Your Customers Better 🚀
    </h3>
    <div class="vf-px-14">
      <p class="text-muted">
        Everything's ready! Start using Lenna.ai to deliver the best service to
        your customers.
      </p>
    </div>

    <base-button
      :theme="'secondary'"
      :customClass="`vf-w-[30%] vf-mt-6 vf-mx-auto vf-flex vf-items-center vf-gap-x-2 vf-justify-center`"
      type="button"
      @click="onGoToDashboard"
    >
      Go To Dashboard
    </base-button>
  </div>
</template>

<script setup>
import { computed } from "vue";

const urlTemp = computed(() => {
  let url = import.meta.env.VITE_APP_URL;
  if (window.location.hostname.split(".")[0] == "damcorp") {
    url = import.meta.env.VITE_DAMCORP_URL;
  } else if (window.location.hostname.split(".")[0] == "bawaslu") {
    url = import.meta.env.VITE_BAWASLU_URL;
  } else if (window.location.hostname.split(".")[0] == "pgd-omni") {
    url = import.meta.env.VITE_PEGADAIAN_URL;
  } else {
    url = import.meta.env.VITE_APP_URL;
  }
  return url;
});

const logoUrl = computed(() => `${urlTemp.value}/img/icons/favicon.svg`);

const onGoToDashboard = () => {
  window.location.reload();
};
</script>
